var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as R from 'ramda';
import * as F from '../../models/formula.types';
import { mapFormDefFlatten, mapElementTreeAsImmutable, mapElementTreeAsMutable, isElementBlock } from './_.utils';
import { mapElementDef } from './raw.utils';
import { XbpmBlockType } from '../../models/xbpm.enums';
// form values
export var mapFormValuesFlatten = mapFormDefFlatten(R.prop('value'));
var setElementValue = function (values) { return function (it) {
    if (R.has(it.id, values)) {
        it.value = values[it.id];
    }
    return it;
}; };
export var setFormValuesAsImmutable = function (def, values) {
    return !values ? def : mapElementTreeAsImmutable(setElementValue(values))(def);
};
export var setFormValuesAsMutable = function (def, values) {
    return !values ? def : mapElementTreeAsMutable(setElementValue(values))(def);
};
// find element
var _findElementWith = function (cond, items) {
    return R.reduceWhile(function (it) { return !it; }, function (_, it) {
        return cond(it) ? it : isElementBlock(it) ? (it.elements ? _findElementWith(cond, it.elements) : null) : null;
    }, null, items);
};
var _findElementBy = function (prop, value, items) {
    return _findElementWith(R.propEq(prop, value), items);
};
export var findElementBy = R.curry(function (prop, value, def) {
    return def ? _findElementBy(prop, value, [def]) : null;
});
export var findElementWith = R.curry(function (cond, def) { return (def ? _findElementWith(cond, [def]) : null); });
export var updateElementWith = function (cond, updateFn, def, parent) {
    return R.ifElse(cond, function (it) { return updateFn(it, parent); }, R.evolve({
        elements: R.map(function (it) { return updateElementWith(cond, updateFn, it, def); }),
    }))(def);
};
export var updateElementBy = function (propName, propValue, updateFn, def, parent) { return updateElementWith(R.propEq(propName, propValue), updateFn, def, parent); };
// update element property
export var updateElementProperty = function (id, propName, value, def) { return updateElementBy('id', id, R.assoc(propName, value), def); };
// replace element
export var replaceElement = function (def, id, newEl, env) {
    return updateElementBy('id', id, function (_, parent) { return mapElementDef(env, newEl, parent, id); }, def);
};
// update elements props
export var applyFormChangesAsImmutable = function (def, changes) {
    if (changes && changes.length) {
        var alloweChanges_1 = changes.filter(function (c) { return R.contains(c.$kind, F.FORMULA_ALLOWED_CHANGES_LIST); });
        if (alloweChanges_1.length) {
            return mapElementTreeAsImmutable(function (element) {
                var elementChanges = alloweChanges_1.filter(R.propEq('id', element.id));
                return elementChanges.length
                    ? R.reduce(function (acc, c) { return R.assoc(c.$kind, c.value, acc); }, element, elementChanges)
                    : element;
            })(def);
        }
    }
    return def;
};
export var applyPropertyChangeAsMutable = function (element, property, value) {
    var propValue = null;
    property = property || F.FormulaChangeProperty.VALUE;
    switch (property) {
        case F.FormulaChangeProperty.OPTIONS:
            propValue = __assign(__assign({}, (element[property] || {})), (value || {}));
            break;
        default:
            propValue = value;
            break;
    }
    var prevValue = element[property];
    element[property] = propValue;
    if (!R.equals(propValue, prevValue)) {
        element.lastChanged = Date.now();
        if (R.contains(element.kind, [XbpmBlockType.TABLE_ROW, XbpmBlockType.TAB]) && element['parent']) {
            element.parent.lastChanged = Date.now();
        }
        return true;
    }
    return false;
};
export var applyFormChangesAsMutable = function (def, changes) {
    if (changes && !R.isEmpty(changes)) {
        return mapElementTreeAsMutable(function (element) {
            if (changes[element.id]) {
                Object.entries(changes[element.id])
                    .filter(function (c) { return R.contains(c[0], F.FORMULA_ALLOWED_CHANGES_LIST); })
                    .forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return applyPropertyChangeAsMutable(element, key, value);
                });
            }
            return element;
        })(def);
    }
    return def;
};
//# sourceMappingURL=def.utils.js.map